import { media, styled } from "@iventis/styles";
import { Content } from "@iventis/translations/content/typed-content";
import { DialogContent, DialogTitle, TextField } from "@mui/material";
import React, { FunctionComponent, useState } from "react";

import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { FormButtonsComponent, StyledDialogActions } from "@iventis/components";

interface CreateTeamProps {
    header: string;
    initialValue?: string;
    submit: (name: string) => void;
    cancel: () => void;
    isSubmitting: boolean;
}

/**
 * Component allows a name or to be added or changed
 * @params header - title to be displayed
 * @params initialValue - a value to use from the start if not provided use an empty string
 * @params submit - a function to handle submit being pressed, accepts a string of the name as a parameter
 * @params cancel - a function to handle cancel being pressed or if the user clicks of the dialog
 * NOTE: Name is not accepted if it is 1 or less characters
 */

export const CreateTeamComponent: FunctionComponent<CreateTeamProps> = ({ header, initialValue = "", submit, cancel, isSubmitting }) => {
    const [value, setValue] = useState(initialValue);
    const translate = useIventisTranslate();

    return (
        <CreateTeamContainer>
            <DialogTitle>{header}</DialogTitle>

            <DialogContent style={{ marginTop: "10px", marginBottom: "40px" }}>
                <div>{translate(Content.people.nameOfTeam)}</div>
                <TextField style={{ width: "100%", marginTop: "10px" }} value={value} onChange={(event) => setValue(event.target.value)} />
            </DialogContent>
            <StyledDialogActions>
                <FormButtonsComponent
                    submitButtonText={translate(Content.common.buttons.confirm)}
                    handleSubmit={() => submit(value)}
                    disableSubmit={() => value.length < 1}
                    isSubmitting={isSubmitting}
                    secondaryButtons={[{ buttonText: translate(Content.common.buttons.cancel), onButtonPressed: cancel }]}
                />
            </StyledDialogActions>
        </CreateTeamContainer>
    );
};

const CreateTeamContainer = styled.div`
    padding: 20px;
    width: 90%;
    ${media.small} {
        width: 500px;
    }
`;
